import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Checkbox } from '../../../../design/inputs/checkbox/S_Checkbox';

interface IProps {
  checked: boolean;
  disabled: boolean;
  onChange: () => void;
}

export const CursorVisibilityCheckbox = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();
  const { checked, onChange, disabled } = props;
  return (
    <div className={`cursor-control-checkbox${disabled && '-disabled'}`}>
      <S_Checkbox
        id='cursor-visibility-checkbox'
        checked={checked}
        onChange={onChange}
        label={t('editor.cursor_control.enable_improved_visibility_cursor')}
        disabled={disabled}
      />
    </div>
  );
});
